module.exports = require('../dist/components/NerdWalletLogo/NerdWalletLogo');
